export default __webpack_public_path__ + "static/media/bg-loop-clouds.7394485.mp4";